import React, { Component } from "react"
import PropTypes from "prop-types"

import FormLoader from "../form-loader"

const $script = typeof document !== "undefined" ? require("scriptjs") : null
const postscribe = typeof window !== "undefined" ? require("postscribe") : null

class LightningOut extends Component {
  state = {
    loaded: false,
  }

  getFSWrapperClass() {
    const { blok } = this.props
    const { loaded } = this.state
    if (!blok._editable && !loaded) {
      return " fs-wrapper--loading"
    }
    return ""
  }
  componentDidMount() {
    const { _uid, script, wrapper, name } = this.props.blok

    if ($script && postscribe)
      $script(script, () => {
        if (window.$Lightning)
          postscribe(
            this.instance,
            `<script>
              $Lightning.use("c:${wrapper}", function() {
                  $Lightning.createComponent(
                      "c:${name}",
                      {},
                      "${_uid}",
                      function(cmp) {});
              });
            </script>`,
            {
              done: () => this.setState({ loaded: true }),
            }
          )
      })
  }

  render = () => (
    <div
      id={this.props.blok._uid}
      ref={el => (this.instance = el)}
      className={`fs-wrapper${this.getFSWrapperClass()}`}
    >
      {!this.state.loaded && <FormLoader className="fs-wrapper__loading" />}
    </div>
  )
}

LightningOut.propTypes = {
  blok: PropTypes.shape({
    _uid: PropTypes.string.isRequired,
    script: PropTypes.string.isRequired,
    wrapper: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
}

export default LightningOut
